import React from 'react';
import { Box } from '@fiverr-private/theme';
import { Link } from '@fiverr-private/typography';
import { Tooltip } from '@fiverr-private/tooltip';
import { findChildByType, renderChildren } from '@fiverr-private/ui_utils';
import { paddingLastChild } from '../styles.ve.css';
import { type BreadcrumbsLinkProps } from './types';

const BreadcrumbsLink = ({ children, disabled, tooltipContent, ...restProps }: BreadcrumbsLinkProps) => {
  const breadcrumbsHomeIcon = findChildByType(children, 'BreadcrumbsHomeIcon');

  const content = breadcrumbsHomeIcon ? (
    renderChildren(breadcrumbsHomeIcon, { disabled, ...restProps })
  ) : (
    <Link
      fontSize="b_sm"
      decoration={{ hover: 'underline' }}
      outlineOffset={{ focusVisible: 'lg' }}
      disabled={disabled}
      color="inherit"
      {...restProps}
    >
      {children}
    </Link>
  );

  return (
    <Box as="li" whiteSpace="nowrap" boxSizing="borderBox" className={paddingLastChild}>
      {tooltipContent ? (
        <Tooltip offset={breadcrumbsHomeIcon ? 12 : 6} content={tooltipContent}>
          {content}
        </Tooltip>
      ) : (
        content
      )}
    </Box>
  );
};

export default BreadcrumbsLink;
BreadcrumbsLink.id = 'BreadcrumbsLink';
BreadcrumbsLink.displayName = 'BreadcrumbsLink';
